import * as React from 'react';
import axios from 'axios';
import AxiosConfig from '../../../utilities/AxiosConfig';
import InfoButton from '../../common/InfoButton';
// Highcharts
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import Loader from '../../common/Loader';
import logger from '../../../utilities/logging';
import './loginSessions.css';

export interface SessionActivityProps {
    fromutc: Date | null | undefined,
    toutc: Date | null | undefined,
    parentRefreshing: boolean
}

export interface SessionActivityState {
    loading: boolean,
    data: Array<[string, number]>,
    categories: Array<string>
}

class SessionActivity extends React.Component<SessionActivityProps, SessionActivityState> {
    ref: any = "MetricsGraph"
    constructor(props: SessionActivityProps) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            categories: []
        }
    }

    componentDidMount() {
        this.getSessionActivity(this.props.fromutc, this.props.toutc);
    }

    getSessionActivity = (fromutc: Date | null | undefined = null, toutc: Date | null | undefined = null) => {
        this.setState({ loading: true })
        let requestBody: { toutc: Date | null, fromutc: Date | null } = {
            fromutc: null,
            toutc: null
        }
        let config: any = { ...AxiosConfig.configValue() };
        if (fromutc && toutc) {
            requestBody.fromutc = fromutc;
            requestBody.toutc = toutc;
            config.params = requestBody;
        }
        let url = process.env.REACT_APP_API_URL + "/api/ops/sessionactivity";
        axios.get(url, config)
            .then(response => {
                //console.log("Session activity", response.data);
                let categories: Array<string> = [];
                let data: Array<any> = [];
                response.data.forEach((item: { UserName: string, AccessCount: number }) => {
                    categories.push(item.UserName);
                    data.push([item.UserName, item.AccessCount]);
                })
                this.setState({ data, categories })
            })
            .catch(error => {
                //console.log(error, error.response);
                logger.Error({
                    EventMessage: `SessionActivity.tsx -> getSessionActivity -> Error : ${error?.response}`,
                    EventCategory: "httprequest"
                })
                AxiosConfig.handleError(error);
            })
            .finally(() => {
                this.setState({ loading: false });
            })
    }

    render() {
        const { loading, data, categories } = this.state;
        return (
            <div className="w-100">
                <div className="toolbar-item-50 d-flex flex-row align-items-center">
                    <h5>Session Activity Counts</h5>
                    <InfoButton place="bottom" id="SessionActivity-info ml-2">
                        <p>Total number of session hits per user for sessions created during time range.</p>
                    </InfoButton>
                </div>
                {
                    loading
                        ?
                        <div className="w-100 d-flex justify-content-center align-items-center">
                            <Loader title="Loading Session Activity..." />
                        </div>
                        :
                        <div className="toolbar-item-50">
                            {
                                this.props.parentRefreshing
                                    ?
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={{
                                            chart: {
                                                type: "bar"
                                            },
                                            title: {
                                                text: ""
                                            },
                                            series: [
                                                {
                                                    name: "Activity Count",
                                                    type: "bar",
                                                    data: [],
                                                }
                                            ],
                                            xAxis: {
                                                categories: [],
                                            },
                                            yAxis: {
                                                min: 0,
                                                title: {
                                                    text: "Access Count",
                                                }
                                            },
                                            credits: {
                                                enabled: false
                                            },
                                        }}
                                    />
                                    :
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={{
                                            chart: {
                                                type: "bar"
                                            },
                                            title: {
                                                text: ""
                                            },
                                            series: [
                                                {
                                                    name: "Activity Count",
                                                    type: "bar",
                                                    data: data,
                                                }
                                            ],
                                            xAxis: {
                                                categories: categories,
                                            },
                                            yAxis: {
                                                min: 0,
                                                title: {
                                                    text: "Access Count",
                                                }
                                            },
                                            plotOptions: {
                                                bar: {
                                                    dataLabels: {
                                                        enabled: true
                                                    }
                                                }
                                            },
                                            credits: {
                                                enabled: false
                                            },
                                        }}
                                        ref={this.ref}
                                        allowChartUpdate={true}
                                    />
                            }
                        </div>
                }
            </div>
        );
    }
}

export default SessionActivity;